import BodyScroll from "../common/utils/BodyScroll";
import { isSpSize } from "../common/utils/isSpSize";
import Transition from "../topPage/Transition";

const init = () => {
  Vue.component("accordion", {
    template: "#sp_menu__accordion",
    props: ["initOpen", "menuTitleUrl"],
    data() {
      return {
        isOpen: false,
      };
    },
    methods: {
      toggle() {
        this.isOpen = !this.isOpen;
      },
      reset() {
        this.isOpen = false;
      },
    },
    created() {
      this.isOpen = !!this.initOpen;
    },
  });
  new Vue({
    el: "#global_header",
    delimiters: ["${", "}"],
    data: {
      activeMenu: 0,
      activeSecondMenu: 0,
      currentSecondMenu: 0,
      globalCurrent: "",
      activeMenuMobile: false,
      companyFirstMenu: window.companyFirstMenu,
      technologyFirstMenu: window.technologyFirstMenu,
      investorsFirstMenu: window.investorsFirstMenu,
      technologySecondFlatSawing: window.technologySecondFlatSawing,
      technologySecondCoreDrilling: window.technologySecondCoreDrilling,
      technologySecondWallSaw: window.technologySecondWallSaw,
      technologySecondWireSaw: window.technologySecondWireSaw,
      technologySecondGrooving: window.technologySecondGrooving,
      technologySecondOthers: window.technologySecondOthers,
      technologySecondDedicatedCar: window.technologySecondDedicatedCar,
      technologySecondRobot: window.technologySecondRobot,
      technologySecondSakkou: window.technologySecondSakkou,
      technologySecondLance: window.technologySecondLance,
      technologySecondSpinjet: window.technologySecondSpinjet,
      technologySecondAquablast: window.technologySecondAquablast,
      technologySecondIndustry: window.technologySecondIndustry,
      technologySecondBlast: window.technologySecondBlast,
      technologySecondGrinding: window.technologySecondGrinding,
    },
    methods: {
      menuChange(id, name) {
        if (this.activeMenu === id) {
          this.menuClose();
        } else {
          this.activeMenu = id;
          this.globalCurrent = name;
          document.querySelector(".c-overlay").style.display = "block";
          BodyScroll.fixed(true);
        }
      },
      menuClose() {
        this.activeMenu = 0;
        this.globalCurrent = null;
        document.querySelector(".c-overlay").style.display = "none";
        BodyScroll.fixed(false);
      },
      secondMenuChange(id) {
        if (this.activeSecondMenu === id) {
          this.activeSecondMenu = 0;
          this.currentSecondMenu = 0;
        } else {
          this.activeSecondMenu = id;
          this.currentSecondMenu = id;
        }
      },
      menuMobileToggle() {
        this.activeMenuMobile = !this.activeMenuMobile;
        if (!this.activeMenuMobile) {
          const spMenu = document.querySelector(".p-sp-menu__contents");
          BodyScroll.fixed(false);
          spMenu.scrollTo(0, 0);

          let arr = [1, 2, 3];
          for (var i = 0; i < arr.length; i++) {
            let ref = this.$refs["accordion" + arr[i]];
            ref.reset();
          }
        } else {
          BodyScroll.fixed(true);
        }
      },
      reset() {
        const ua = navigator.userAgent;
        if (
          (ua.indexOf("iPhone") > 0 || ua.indexOf("Android") > 0) &&
          ua.indexOf("Mobile") > 0
        ) {
          return false;
        }
        this.activeMenuMobile = false;
        this.menuClose();
      },
    },
    mounted() {
      const overlay = document.querySelector(".c-overlay");

      overlay.addEventListener("click", this.menuClose);
      // window.addEventListener("resize", this.reset);

      // 離脱アニメーションの実行
      $("#global_header").on("click", "a", function () {
        if (document.querySelector("#page_home") && !isSpSize()) {
          const href = $(this).attr("href");
          const target = $(this).attr("target");
          if (target != "_blank") {
            Transition.show(href);
            return false;
          }
        }
      });
    },
  });
};

export { init };
